import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, ListItem, ListItemText, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { useListaCboService } from "../../../../../../../../use-cases/geo-veles/lista-cbo"
import { FixedSizeList, ListChildComponentProps } from "react-window"
import AutoSizer from "react-virtualized-auto-sizer"
// Icons
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import { theme } from "../../../../../../../styles"

function RenderActualCbos(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCbo } = useAppSelector((state: any) => state)

    // Se a lista não tem CBOs ou está vazia, consideramos que é uma nova lista
    const cbosExistentes = listaCbo.editListaCboForm.fields.CBOs || [];
    const cbosAtuais = cbosExistentes.length > 0 ? cbosExistentes : [];

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={cbosAtuais[index] ?? ''} />
        </ListItem>
    );
}

function RenderNewCbos(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCbo } = useAppSelector((state: any) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={listaCbo.fileListData.fileListValidTable.fileListValidData[index] ?? ''} />
        </ListItem>
    );
}

function RenderRepeatedCbos(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCbo } = useAppSelector((state: any) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={listaCbo.fileListData.fileListValidTable.fileListRepeatedData[index] ?? ''} />
        </ListItem>
    );
}

function RenderInvalidCbos(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCbo } = useAppSelector((state: any) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={listaCbo.fileListData.fileListValidTable.fileListInvalidData[index] ?? ''} />
        </ListItem>
    );
}

export const PreviewListaCBO = (props: {
    openPreviewListaCBO: boolean
}) => {
    // State
    const { listaCbo } = useAppSelector((state: any) => state)
    // Hook
    const { openPreviewListaCbo, addFileListToListaCBO, openImportFileListaCbos } = useListaCboService()

    return (
        <>
            {
                props.openPreviewListaCBO === true &&
                <>
                    <Dialog
                        fullWidth
                        maxWidth={'lg'}
                        open={listaCbo.openPreviewFileListaCbo}
                        onClose={() => {
                            openPreviewListaCbo(false)
                        }}
                    >
                        <DialogTitle>
                            <Typography fontWeight={'bold'} textTransform="uppercase" variant="h5" color='primary'>
                                Pré visualização do arquivo - <strong>{listaCbo.fileData.name}</strong>
                            </Typography>
                        </DialogTitle>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main}/>
                        </Box>
                        <DialogContent>
                            <Grid container
                                height={300}
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    overflowY: 'hidden'
                                }}
                            >
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddCheckIcon sx={{ width: '8%', height: '8%' }} /> CBOs atuais:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => {
                                            // Se a lista não tem CBOs ou está vazia, consideramos que é uma nova lista
                                            const cbosExistentes = listaCbo.editListaCboForm.fields.CBOs || [];
                                            const cbosAtuais = cbosExistentes.length > 0 ? cbosExistentes : [];
                                            
                                            return (
                                                <FixedSizeList
                                                    height={data.height}
                                                    width={data.width}
                                                    itemSize={46}
                                                    itemCount={cbosAtuais.length}
                                                    overscanCount={5}
                                                    style={{
                                                        marginTop: 3.5
                                                    }}
                                                >
                                                    {RenderActualCbos}
                                                </FixedSizeList>
                                            );
                                        }}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddIcon sx={{ width: '8%', height: '8%' }} /> CBOs novos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCbo.fileListData.fileListValidTable.fileListValidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderNewCbos}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <SyncProblemIcon sx={{ width: '8%', height: '8%' }} /> CBOs repetidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCbo.fileListData.fileListValidTable.fileListRepeatedData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderRepeatedCbos}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistRemoveIcon sx={{ width: '8%', height: '8%' }} /> CBOs inválidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCbo.fileListData.fileListValidTable.fileListInvalidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderInvalidCbos}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main}/>
                        </Box>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    openPreviewListaCbo(false)
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    addFileListToListaCBO()
                                    openPreviewListaCbo(false)
                                    openImportFileListaCbos(false)
                                }}
                            >
                                Enviar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </>
    )
}
